export default __webpack_public_path__ + "static/media/reactions.db072cb2.svg";